import { JudgementCard } from 'open-modules/zdf/component/moddashboard/judgementcard';
import { CLICK, componentWithVariants, demoFile, INPUT, POPUP, story, variant, WITHIN } from 'system/demo';

import { channelModDashboardDemoData } from '../../channels/__demos__/channel-demo.data';
import { modDashboardDemoData } from './moddashboard-demo.data';

demoFile('open-modules/zdf/component/moddashboard/judgementcard');

const modTask_awaiting = modDashboardDemoData.modTaskQueues.thread1.c_t1_awaiting_ai;
const modTask_approved = modDashboardDemoData.modTaskQueues.thread1.c_t1_approved_auto;
const modTask_rejected = modDashboardDemoData.modTaskQueues.thread1.c_t1_rejected;

const modTaskNoWarning = modDashboardDemoData.modTaskQueues.thread1.c_t1_awaiting_ai;
const modTaskOneWarning = modDashboardDemoData.modTaskQueues.thread1.c_t1_approved_first_warning;
const modTaskTwoWarnings = modDashboardDemoData.modTaskQueues.thread1.c_t1_approved_second_warning_authorH;
const modTask_blockedUser = modDashboardDemoData.modTaskQueues.thread1.c_t1_awaiting_blocked;
const modTaskDeleted = modDashboardDemoData.modTaskQueues.thread1.c_t1_awaiting_deleted;
const modTaskApproved = modDashboardDemoData.modTaskQueues.thread1.c_t1_approved_auto;
const modTaskAwaitingDecision = modDashboardDemoData.modTaskQueues.thread1.c_t1_awaiting_ai;

const myWatchState = { ...modDashboardDemoData.watchStates.c_t1_approved_auto, amIViewing: true };
const otherWatchState = modDashboardDemoData.watchStates.c_t1_approved_auto;

componentWithVariants(
    'JudgementCard',
    JudgementCard,
    {
        state: {
            // modulePublic: modDashboardDemoData.modulePublic,
            serverCall: modDashboardDemoData.serverCalls,
        },
    },
    [
        variant('Approved comment', {
            args: {
                modTask: modTask_approved,
                modAuthor: modDashboardDemoData.demoModAuthors[modTask_approved.key],
                isSelected: true,
                taskWatchState: undefined,
                onCollapse: () => {},
            },
        }),
        variant('Rejected comment', {
            args: {
                modTask: modTask_rejected,
                modAuthor: modDashboardDemoData.demoModAuthors[modTask_rejected.key],
                isSelected: true,
                taskWatchState: undefined,
                onCollapse: () => {},
            },
        }),
        variant('Awaiting decision', {
            args: {
                modTask: modTask_awaiting,
                modAuthor: modDashboardDemoData.demoModAuthors[modTask_awaiting.key],
                isSelected: true,
                taskWatchState: undefined,
                onCollapse: () => {},
            },
        }),
        variant('Comment card selected, I am reviewing', {
            args: {
                modTask: modTask_approved,
                modAuthor: modDashboardDemoData.demoModAuthors[modTask_approved.key],
                isSelected: true,
                taskWatchState: myWatchState,
                onCollapse: () => {},
            },
        }),
        variant('Comment card selected, other moderator is reviewing', {
            args: {
                modTask: modTask_approved,
                modAuthor: modDashboardDemoData.demoModAuthors[modTask_approved.key],
                isSelected: true,
                taskWatchState: otherWatchState,
                onCollapse: () => {},
            },
        }),
        variant('Comment card not selected, I am reviewing', {
            args: {
                modTask: modTask_approved,
                modAuthor: modDashboardDemoData.demoModAuthors[modTask_approved.key],
                isSelected: false,
                taskWatchState: myWatchState,
                onCollapse: () => {},
            },
        }),
        variant('Comment card not selected, other moderator is reviewing', {
            args: {
                modTask: modTask_approved,
                modAuthor: modDashboardDemoData.demoModAuthors[modTask_approved.key],
                isSelected: false,
                taskWatchState: otherWatchState,
                onCollapse: () => {},
            },
        }),
        variant(
            'User has no warnings',
            {
                args: {
                    modTask: modTaskNoWarning,
                    modAuthor: modDashboardDemoData.demoModAuthors[modTaskNoWarning.key],
                    isSelected: true,
                    taskWatchState: undefined,
                    onCollapse: () => {},
                },
            },
            [
                story('Approve', [CLICK('Approve')]),
                story('Reject', [CLICK('Reject'), CLICK('Reject')]),
                story('Reject and change violations', [
                    CLICK('Reject'),
                    CLICK('Express your ideas with civility'),
                    CLICK('No violent content or calls for harm'),
                    CLICK('Avoid sarcasm and dismissive responses'),
                    CLICK('Reject'),
                ]),
                story('Reject and warn', [
                    CLICK('Reject'),
                    CLICK('Express your ideas with civility'),
                    CLICK('Avoid sarcasm and dismissive responses'),
                    WITHIN('judgementCard-' + modTaskNoWarning.key, CLICK('warn-toggle')),
                    CLICK('Reject and warn'),
                ]),
                story('Reject and go back', [
                    CLICK('Reject'),
                    CLICK('Other'),
                    CLICK('No violent content or calls for harm'),
                    CLICK('Back to selection'),
                ]),
                story('Reject with custom message', [
                    CLICK('Reject'),
                    CLICK('Add explanation to user'),
                    POPUP(INPUT('textfield-explanation-to-user', 'Dear user, please avoid doing this.')),
                    POPUP(CLICK('Save')),
                    CLICK('Reject'),
                ]),
                story('Reject and edit custom message', [
                    CLICK('Reject'),
                    CLICK('Add explanation to user'),
                    POPUP(INPUT('textfield-explanation-to-user', 'Dear user, please avoid doing this.')),
                    POPUP(CLICK('Save')),
                    CLICK('Edit'),
                    POPUP(
                        INPUT(
                            'textfield-explanation-to-user',
                            'Dear user, please avoid doing this because it creates a hostile environment for everyone.',
                        ),
                    ),
                    POPUP(CLICK('Save')),
                    CLICK('Reject'),
                ]),
                story('Reject and delete custom message', [
                    CLICK('Reject'),
                    CLICK('Add explanation to user'),
                    POPUP(INPUT('textfield-explanation-to-user', 'Dear user, please avoid doing this.')),
                    POPUP(CLICK('Save')),
                    CLICK('Delete'),
                    CLICK('Reject'),
                ]),
            ],
        ),
        variant(
            'User has 1 warning',
            {
                args: {
                    modTask: modTaskOneWarning,
                    modAuthor: modDashboardDemoData.demoModAuthors[modTaskOneWarning.key],
                    isSelected: true,
                    taskWatchState: undefined,
                    onCollapse: () => {},
                },
            },
            [
                story('Reject and warn', [
                    WITHIN('judgementCard-' + modTaskOneWarning.key, CLICK('Reject')),
                    WITHIN('judgementCard-' + modTaskOneWarning.key, CLICK('Express your ideas with civility')),
                    WITHIN('judgementCard-' + modTaskOneWarning.key, CLICK('No violent content or calls for harm')),
                    WITHIN('judgementCard-' + modTaskOneWarning.key, CLICK('warn-toggle')),
                    WITHIN('judgementCard-' + modTaskOneWarning.key, CLICK('Reject and warn')),
                ]),
            ],
        ),
        variant(
            'Judgement Card - User has 2 warnings',
            {
                args: {
                    modTask: modTaskTwoWarnings,
                    modAuthor: modDashboardDemoData.demoModAuthors[modTaskTwoWarnings.key],
                    isSelected: true,
                    taskWatchState: undefined,
                    onCollapse: () => {},
                },
            },
            [
                story('Reject and warn', [
                    WITHIN('judgementCard-' + modTaskTwoWarnings.key, CLICK('Reject')),
                    WITHIN('judgementCard-' + modTaskTwoWarnings.key, CLICK('Express your ideas with civility')),
                    WITHIN('judgementCard-' + modTaskTwoWarnings.key, CLICK('No violent content or calls for harm')),
                    WITHIN('judgementCard-' + modTaskTwoWarnings.key, CLICK('warn-toggle')),
                    WITHIN('judgementCard-' + modTaskTwoWarnings.key, CLICK('Reject and warn')),
                ]),
                story('Reject, warn and block', [
                    WITHIN('judgementCard-' + modTaskTwoWarnings.key, CLICK('Reject')),
                    WITHIN('judgementCard-' + modTaskTwoWarnings.key, CLICK('Express your ideas with civility')),
                    WITHIN('judgementCard-' + modTaskTwoWarnings.key, CLICK('No violent content or calls for harm')),
                    WITHIN('judgementCard-' + modTaskTwoWarnings.key, CLICK('warn-toggle')),
                    WITHIN('judgementCard-' + modTaskTwoWarnings.key, CLICK('block-toggle')),
                    WITHIN('judgementCard-' + modTaskTwoWarnings.key, CLICK('Reject and block')),
                ]),
                story('Reject and block', [
                    CLICK('Reject'),
                    CLICK('Other'),
                    CLICK('No violent content or calls for harm'),
                    CLICK('block-toggle'),
                    CLICK('Reject and block'),
                ]),
                story('Reject, block, reset', [
                    CLICK('Reject'),
                    CLICK('Other'),
                    CLICK('No violent content or calls for harm'),
                    CLICK('block-toggle'),
                    CLICK('block-toggle'),
                    CLICK('Reject'),
                ]),
                story('Reject and open user profile', [
                    CLICK('Reject'),
                    CLICK('Express your ideas with civility'),
                    CLICK('No violent content or calls for harm'),
                    CLICK('Avoid sarcasm and dismissive responses'),
                    CLICK('Show user profile'),
                    CLICK('Reject'),
                ]),
            ],
        ),
        variant(
            'Warnings disabled',
            {
                args: {
                    modTask: modTask_awaiting,
                    modAuthor: modDashboardDemoData.demoModAuthors[modTask_awaiting.key],
                    isSelected: true,
                    taskWatchState: undefined,
                    onCollapse: () => {},
                },
            },
            [
                story('Reject with warnings disabled', [
                    CLICK('Reject'),
                    CLICK('Other'),
                    CLICK('No violent content or calls for harm'),
                    CLICK('Reject'),
                ]),
            ],
        ),
        variant(
            'Blocked user',
            {
                args: {
                    modTask: modTask_blockedUser,
                    modAuthor: modDashboardDemoData.demoModAuthors[modTask_blockedUser.key],
                    isSelected: true,
                    taskWatchState: undefined,
                    onCollapse: () => {},
                },
            },
            [story('Reject', [CLICK('Reject'), CLICK('Other'), CLICK('Avoid sarcasm and dismissive responses'), CLICK('Reject')])],
        ),
        variant(
            'Deleted comment',
            {
                args: {
                    modTask: modTaskDeleted,
                    modAuthor: modDashboardDemoData.demoModAuthors[modTaskDeleted.key],
                    isSelected: true,
                    taskWatchState: undefined,
                    onCollapse: () => {},
                },
            },
            [
                story('Approve', [CLICK('Approve')]),
                story('Reject', [CLICK('Reject'), CLICK('Avoid sarcasm and dismissive responses'), CLICK('Reject')]),
            ],
        ),
        variant(
            'Approved comment with channel',
            {
                state: {
                    modulePublic: channelModDashboardDemoData.modulePublic,
                    serverCall: channelModDashboardDemoData.serverCalls && modDashboardDemoData.serverCalls,
                },
                args: {
                    modTask: modTaskApproved,
                    modAuthor: modDashboardDemoData.demoModAuthors[modTaskApproved.key],
                    isSelected: true,
                    taskWatchState: undefined,
                    onCollapse: () => {},
                },
            },
            [
                story('Reply', [CLICK('Reply'), POPUP(INPUT('textfield-editorial-comment', 'Thanks for sharing!')), POPUP(CLICK('Post'))]),
                story('Reply and cancel', [
                    CLICK('Reply'),
                    POPUP(INPUT('textfield-editorial-comment', 'Thanks for sharing!')),
                    POPUP(CLICK('Cancel')),
                ]),
            ],
        ),
        variant(
            'Comment awaiting decision with channel',
            {
                state: {
                    modulePublic: channelModDashboardDemoData.modulePublic,
                    serverCall: channelModDashboardDemoData.serverCalls && modDashboardDemoData.serverCalls,
                },
                args: {
                    modTask: modTaskAwaitingDecision,
                    modAuthor: modDashboardDemoData.demoModAuthors[modTaskAwaitingDecision.key],
                    isSelected: true,
                    taskWatchState: undefined,
                    onCollapse: () => {},
                },
            },
            [story('Approve', [CLICK('Approve')])],
        ),
    ],
);
